import React from 'react'

const Loader = () => {
  return (

    // Loader for buttons
    <span className='loader'></span>
  )
}

export default Loader